import React, { useEffect, useState } from "react";
import { useAppSelector } from "../../../../hooks/useAppDispatch";
import { RootState } from "../../../../redux/store";
import { useTranslation } from "react-i18next";
import { withTranslations } from "../../../../hoc/withTranslations/withTranslations";

const LOCALE = "modules_MyGiftTable_components_AsideSection_TableValue";

const TableValue: React.FC = () => {
  const { t } = useTranslation(LOCALE);
  const [shouldBlink, setShouldBlink] = useState(false);
  const { totalValue = 0 } = useAppSelector(
    (state: RootState) => state.giftTable
  );

  // Trigger blink animation when totalValue changes
  useEffect(() => {
    setShouldBlink(true);
    const timer = setTimeout(() => setShouldBlink(false), 1000);
    return () => clearTimeout(timer);
  }, [totalValue]);

  return (
    <div
      className={`bg-secondary p-4 rounded-md space-y-4 ${
        shouldBlink ? "highlight-blink" : ""
      }`}
    >
      <div>
        <p className="text-sm">{t("title")}</p>
        <h4 className="text-lg font-bold">
          {totalValue.toLocaleString("es-MX", {
            style: "currency",
            currency: "MXN",
          })}
        </h4>
      </div>
    </div>
  );
};

export default withTranslations(LOCALE)(TableValue);
